export default function (element: HTMLElement, dataset: DOMStringMap) {
  // console.log("formgate", element.children);

  setTimeout(() => {
    // Get all input fields in the form
    const inputs = element.querySelectorAll("input, textarea, select");

    // Function to check if all visible fields are filled
    const checkAllFields = () => {
      const visibleInputs = Array.from(inputs).filter((input) => {
        const inputElement = input as HTMLElement;
        const style = window.getComputedStyle(inputElement);
        return (
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          inputElement.offsetParent !== null
        );
      });

      const allFieldsFilled = visibleInputs.every((input) => {
        const inputElement = input as
          | HTMLInputElement
          | HTMLTextAreaElement
          | HTMLSelectElement;
        return inputElement.value.trim() !== "";
      });

      if (allFieldsFilled) {
        // console.log("All form fields are filled!");
        // Create cookie called "goose"
        document.cookie = "goose=true; path=/; max-age=31536000"; // expires in 1 year
        console.log("Cookie 'goose' has been set!");
      } else {
        // console.log("Some form fields are still empty");
      }
    };

    // Add event listeners to all form fields
    inputs.forEach((input) => {
      input.addEventListener("input", checkAllFields);
      input.addEventListener("change", checkAllFields);
    });

    // Check initially in case fields are pre-filled
    checkAllFields();
  }, 1000);
}

// // Helper function to check if the "goose" cookie exists
// export function checkGooseCookie() {
//   // Check for "letmein" query parameter
//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.get("letmein")) {
//     console.log("letmein parameter found, skipping redirect");
//     return;
//   }

//   const cookies = document.cookie.split("; ");
//   const ck = cookies.find((cookie) => cookie.startsWith("goose="));
//   if (!ck) {
//     window.location.href = window.location.origin + "/resources/report/sotw-26";
//   } else {
//     console.log("cookie is in");
//   }
// }
